import React from "react"
// import PropTypes from 'prop-types'

import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import PYPSidebarItem from "../PYPSidebarItem/PYPSidebarItem"
import colors from "../../Constants/colors"
import Actions from "../../Redux/Actions"
import { gtmClickHandler } from "../../Utils/gtm"
import PYPDownloadContainer from "../PYPDownloadContainer/PYPDownloadContainer"
import { buildWorkshopLocation } from "../../Utils/workshopNavigation"

export class PYPSidebar extends React.Component {
  constructor(props) {
    super(props)
    this.navItemClickHandler = this.navItemClickHandler.bind(this)
  }

  navItemClickHandler(module) {
    gtmClickHandler({
      name: "SidebarModuleClickEvent",
      data: {
        action: "Sidebar Module Click",
        category: "PYP Engagement",
        label: module.title
      }
    })
  }

  isModuleLocked(index) {
    const { unlockedUserModules, modules } = this.props.pyp
    const allIds = modules?.allIds || []
    if (index === 0) return false
    const previousModuleId = allIds[index - 1]
    const previousUserModule = unlockedUserModules?.find(
      (um) => um.module_id === previousModuleId
    )
    return !previousUserModule ||
      (previousUserModule.completed !== 1 && previousUserModule.completed !== true)
  }

  getStyle(item, index) {
    const { unlockedUserModules } = this.props.pyp
    if (this.isModuleLocked(index)) {
      return { opacity: 0.5, cursor: "not-allowed" }
    }
    const currentUserModule = unlockedUserModules?.find(
      (um) => um.module_id === item.id
    )
    if (currentUserModule?.completed === 1 || currentUserModule?.completed === true) {
      return { opacity: 0.75, fontWeight: "bold" }
    }
    return undefined
  }

  render() {
    return (
      <div style={styles.sidebarContainer} className="sidebarContainer">
        <div style={styles.sidebarContent} className="sidebarContent">
          <div style={styles.sidebarHeader}>
            <div style={styles.headerTitle}>
              {this.props.pyp.navigation.currentCourseName ||
                "Pursue Your Purpose"}
            </div>
            <div style={{ height: "20px" }} />
            <div style={styles.horizontalBar} />
            <div style={{ height: "20px" }} />
          </div>

          <div style={styles.sidebarItemsContainer}>
            {this.props.pyp.modules.allIds.map((moduleId, i) => {
              const item = this.props.pyp.modules.byId[moduleId]
              const isLocked = this.isModuleLocked(i)

              return (
                <PYPSidebarItem
                  key={i}
                  uniqueKey={i}
                  item={item}
                  linkTo={buildWorkshopLocation(
                    item.title,
                    this.props.pyp.navigation
                  )}
                  textStyle={this.getStyle(item, i)}
                  isSelected={
                    item.id === this.props.pyp.navigation.currentModuleId
                  }
                  clickHandler={
                    isLocked ? undefined : () => this.navItemClickHandler(item)
                  }
                />
              )
            })}
          </div>
        </div>

        <div
          style={styles.sideBarSectionFixedBottom}
          className="sidebarLowerSection"
        >
          <PYPDownloadContainer />
        </div>
      </div>
    )
  }
}

const styles = {
  sidebarContainer: {
    display: "flex",
    width: "100%",
    height: "100%",
    minHeight: "calc(100vh - 60px)",
    flexDirection: "column",
    justifyContent: "space-between",
    paddingRight: "15px",
    zIndex: 2
  },
  sidebarContent: {
    // Container for the logo, progress dial, and nav items
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "flex-start",
    // padding: '10px 0px 20px 30px',
    minHeight: "65px"
  },
  sidebarHeader: {
    minHeight: "100px",
    paddingTop: "50px",
    paddingLeft: "30px"
  },
  headerTitle: {
    fontFamily: "Lato-Bold",
    fontSize: "20px",
    whiteSpace: "nowrap",
    lineHeight: "42px",
    color: colors.white
  },
  horizontalBar: {
    width: "100%",
    borderBottom: `solid 1px ${colors.mediumBlue}`
  },
  sidebarItemsContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    // So that scrolling is enabled when height of side bar is small
    flexGrow: 1,
    overflow: "auto",
    padding: "0px",
    // justifyContent: "space-between",
    minHeight: 0 /* for Firefox */
  },
  sideBarSectionFixedBottom: {
    // fixed to bottom - this only contains the submit button
    // the extra 15px accounts for the padding on the right of the sidebar to ensure the download button extends the component
    width: "calc(100% + 15px)"
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    pyp: state.pyp
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PYPSidebar)
)
